module.exports = __webpack_public_path__ + "static/img/grid_center.022a17d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/dec/grid_center.png
// module id = X+sz
// module chunks = 34